import { type OpenApiLinkDeliveryServiceType, type OpenApiLinkDisplayServiceType } from '../../api/schema';
import { OZON_SERVICE_NAME } from '../brand';

interface DeliveryServicesTitlesMapping {
    title: string;
    titleGenitive: string;
    titleAccusative: string;
    titleInstrumental: string;
}

type ServiceType = OpenApiLinkDeliveryServiceType | OpenApiLinkDisplayServiceType;

export const DELIVERY_SERVICES_MAPPING: { [K in ServiceType]: K } = {
    OZON_FBS: 'OZON_FBS',
    YANDEX_DELIVERY: 'YANDEX_DELIVERY',
    CDEK: 'CDEK',
    META_SHIP_DALLI: 'META_SHIP_DALLI',
    META_SHIP_RUSSIAN_POST: 'META_SHIP_RUSSIAN_POST',
    META_SHIP_PECOM: 'META_SHIP_PECOM',
    HOLODILNIK: 'HOLODILNIK',
    MERCHANT_SHIP: 'MERCHANT_SHIP',
    OZON: 'OZON',
    YANDEX_MARKET_FBO: 'YANDEX_MARKET_FBO',
    '5POST': '5POST',
    YCP_DELIVERY: 'YCP_DELIVERY',
};

export const DELIVERY_SERVICES_MAPPING_TITLES = {
    [DELIVERY_SERVICES_MAPPING.YANDEX_DELIVERY]: {
        title: 'Яндекс Доставка',
        titleGenitive: 'Яндекс Доставки',
        titleAccusative: 'Яндекс Доставку',
        titleInstrumental: 'Яндекс Доставке',
    },
    [DELIVERY_SERVICES_MAPPING.OZON_FBS]: {
        title: `${OZON_SERVICE_NAME} Доставка`,
        titleGenitive: `${OZON_SERVICE_NAME} Доставки`,
        titleAccusative: `${OZON_SERVICE_NAME} Доставку`,
        titleInstrumental: `${OZON_SERVICE_NAME} Доставке`,
    },
    [DELIVERY_SERVICES_MAPPING.CDEK]: {
        title: 'СДЭК',
        titleGenitive: 'СДЭКа',
        titleAccusative: 'СДЭК',
        titleInstrumental: 'СДЭК',
    },
    [DELIVERY_SERVICES_MAPPING.META_SHIP_DALLI]: {
        title: 'Dalli',
        titleGenitive: 'Dalli',
        titleAccusative: 'Dalli',
        titleInstrumental: 'Dalli',
    },
    [DELIVERY_SERVICES_MAPPING.META_SHIP_RUSSIAN_POST]: {
        title: 'Почта России',
        titleGenitive: 'Почты России',
        titleAccusative: 'Почту России',
        titleInstrumental: 'Почте России',
    },
    [DELIVERY_SERVICES_MAPPING.META_SHIP_PECOM]: {
        title: 'ПЭК',
        titleGenitive: 'ПЭКа',
        titleAccusative: 'ПЭК',
        titleInstrumental: 'ПЭК',
    },
    [DELIVERY_SERVICES_MAPPING.HOLODILNIK]: {
        title: 'Холодильник',
        titleGenitive: 'Холодильника',
        titleAccusative: 'Холодильник',
        titleInstrumental: 'Холодильнику',
    },
    [DELIVERY_SERVICES_MAPPING.MERCHANT_SHIP]: {
        title: 'Собственная служба доставки',
        titleGenitive: 'Собственной службы доставки',
        titleAccusative: 'Собственную службу доставки',
        titleInstrumental: 'Собственной службе доставки',
    },
    [DELIVERY_SERVICES_MAPPING.OZON]: {
        title: OZON_SERVICE_NAME,
        titleGenitive: OZON_SERVICE_NAME,
        titleAccusative: OZON_SERVICE_NAME,
        titleInstrumental: OZON_SERVICE_NAME,
    },
    [DELIVERY_SERVICES_MAPPING.YANDEX_MARKET_FBO]: {
        title: 'Фулфилмент Яндекс Маркета',
        titleGenitive: 'Фулфилмент Яндекс Маркета',
        titleAccusative: 'Фулфилмент Яндекс Маркета',
        titleInstrumental: 'Фулфилмент Яндекс Маркета',
    },
    [DELIVERY_SERVICES_MAPPING['5POST']]: {
        title: '5Post',
        titleGenitive: '5Post',
        titleAccusative: '5Post',
        titleInstrumental: '5Post',
    },
    [DELIVERY_SERVICES_MAPPING.YCP_DELIVERY]: {
        title: 'Доставка по YCP протоколу',
        titleGenitive: 'Доставки по YCP протоколу',
        titleAccusative: 'Доставку по YCP протоколу',
        titleInstrumental: 'Доставке по YCP протоколу',
    },
} as const satisfies Record<ServiceType, DeliveryServicesTitlesMapping>;

export const DELIVERY_META_SHIP_SERVICES: Array<OpenApiLinkDeliveryServiceType> = [
    DELIVERY_SERVICES_MAPPING.META_SHIP_DALLI,
    DELIVERY_SERVICES_MAPPING.META_SHIP_RUSSIAN_POST,
    DELIVERY_SERVICES_MAPPING.META_SHIP_PECOM,
] as const;

export const DELIVERY_DEFAULT_SERVICES: Array<OpenApiLinkDeliveryServiceType> = [
    DELIVERY_SERVICES_MAPPING.YANDEX_DELIVERY,
    DELIVERY_SERVICES_MAPPING.YANDEX_MARKET_FBO,
    DELIVERY_SERVICES_MAPPING.CDEK,
] as const;

export const DELIVERY_SERVICES: Array<OpenApiLinkDeliveryServiceType> = [
    ...DELIVERY_META_SHIP_SERVICES,
    ...DELIVERY_DEFAULT_SERVICES,
] as const;
